import React, { useState, useMemo, lazy, Suspense } from "react";
import { useQuery } from "@tanstack/react-query";
import { Container, Grid, Box, CircularProgress } from "@mui/material";
import { fetchCountries, fetchCities, fetchHotels } from "./api";
import ImageScroller from "./ImageScroller";
import BookingForm from "./BookingForm";

const ServicesGrid = lazy(() => import("./ServicesGrid"));
const SpecialOffers = lazy(() => import("./SpecialOffers"));

const HotelLanding = () => {
    const [selectedCityCode, setSelectedCityCode] = useState("IN"); // Default to India
    const [currentPage, setCurrentPage] = useState(1);
    const [checkInDate, setCheckInDate] = useState(null);
    const [checkOutDate, setCheckOutDate] = useState(null);
    const [adults, setAdults] = useState(0);
    const [children, setChildren] = useState(0);

    // Fetch countries using React Query (cached and optimized)
    const { data: countries = [] } = useQuery({
        queryKey: ["countries"],
        queryFn: fetchCountries,
    });

    const { data: cities = [] } = useQuery({
        queryKey: ["cities", selectedCityCode],
        queryFn: () => fetchCities(selectedCityCode),
        enabled: !!selectedCityCode,  // Only fetch when city code exists
    });

    const { data: hotels = [] } = useQuery({
        queryKey: ["hotels", selectedCityCode, currentPage],
        queryFn: () => fetchHotels(selectedCityCode, currentPage),
        keepPreviousData: true, // Keeps previous data while fetching new results
    });


    const handleBookNow = () => {
        console.log("Booking details:", { checkInDate, checkOutDate, adults, children });
    };

    return (
        <Box>
            {/* Scrollable Images Section */}
            <Box>
                <ImageScroller />
            </Box>

            {/* Book a Room Component */}
            <Grid sx={{ marginTop: "4%" }}>
                <BookingForm
                    checkInDate={checkInDate}
                    setCheckInDate={setCheckInDate}
                    checkOutDate={checkOutDate}
                    setCheckOutDate={setCheckOutDate}
                    adults={adults}
                    cities={cities}
                    setAdults={setAdults}
                    children={children}
                    setChildren={setChildren}
                    handleBookNow={handleBookNow}
                />
            </Grid>
            {/* Services & Special Offers - Lazy Loaded */}
            <Suspense fallback={<CircularProgress />}>
                <Grid sx={{ marginTop: "4%" }}>
                    <ServicesGrid />
                </Grid>
                <Grid sx={{ marginTop: "4%" }}>
                    <SpecialOffers />
                </Grid>
            </Suspense>
        </Box>
    );
};

export default React.memo(HotelLanding);
